import { HttpParams } from "@angular/common/http";
import { Inject, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

@Pipe({
    name: "drupalTraySrc",
    standalone: false,
})
export class DrupalTraySrcPipe implements PipeTransform {
    constructor(
        private sanitizer: DomSanitizer,
        @Inject(LOCALE) private locale: Locale,
    ) {}

    public transform(drupalTrayName: string): SafeResourceUrl {
        if (!drupalTrayName) {
            return "";
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(
            this.getTraySrc(drupalTrayName),
        );
    }

    /**
     * construct url for encapsulated trays
     *
     * @param trayName name of the drupal tray
     */
    public getTraySrc(trayName: string): string {
        let params: HttpParams = new HttpParams();
        params = params.append("locale", this.locale.code);

        return `/tray/${trayName}?${params.toString()}`;
    }
}
